import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=fca8843e"
import script from "./OrderTable.vue?vue&type=script&lang=js"
export * from "./OrderTable.vue?vue&type=script&lang=js"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=fca8843e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports